import { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LEGACY_TOKEN_KEY = "aximo_team_token";

const TeamAuthContext = createContext(null);
const api = axios.create({ baseURL: API, withCredentials: true });

export function TeamAuthProvider({ children }) {
    const [member, setMember] = useState(null);
    const [loading, setLoading] = useState(true);

    const logout = useCallback(async () => {
        try {
            await api.post("/team/logout");
        } catch {
            /* ignore */
        }
        localStorage.removeItem(LEGACY_TOKEN_KEY);
        setMember(null);
    }, []);

    useEffect(() => {
        let cancelled = false;
        (async () => {
            try {
                const { data } = await api.get("/team/me");
                if (!cancelled) setMember(data);
            } catch {
                const legacy = localStorage.getItem(LEGACY_TOKEN_KEY);
                if (legacy) {
                    try {
                        const { data } = await axios.get(`${API}/team/me`, {
                            headers: { Authorization: `Bearer ${legacy}` },
                        });
                        if (!cancelled) setMember(data);
                    } catch {
                        localStorage.removeItem(LEGACY_TOKEN_KEY);
                    }
                }
            } finally {
                if (!cancelled) setLoading(false);
            }
        })();
        return () => {
            cancelled = true;
        };
    }, []);

    const _postAndHydrate = async (path, body) => {
        const { data } = await api.post(path, body);
        localStorage.setItem(LEGACY_TOKEN_KEY, data.access_token);
        const me = await api.get("/team/me");
        setMember(me.data);
        return me.data;
    };

    const login = (email, password) =>
        _postAndHydrate("/team/login", { email, password });

    const setupPassword = (token_value, password) =>
        _postAndHydrate("/team/setup-password", { token: token_value, password });

    const resetPassword = (token_value, password) =>
        _postAndHydrate("/team/reset-password", { token: token_value, password });

    const token = member
        ? localStorage.getItem(LEGACY_TOKEN_KEY) || "cookie"
        : null;

    return (
        <TeamAuthContext.Provider
            value={{
                token,
                member,
                loading,
                login,
                logout,
                setupPassword,
                resetPassword,
            }}
        >
            {children}
        </TeamAuthContext.Provider>
    );
}

export const useTeamAuth = () => useContext(TeamAuthContext);
